import { z } from 'zod';
import { PackageTypeEnum } from '../domain';

export const CategoriesParamUniversalOptional = z.object({
  type: z.nativeEnum(PackageTypeEnum).optional(),
  id: z.string().uuid().optional(),
});

export const CategoriesParamUniversalRequired =
  CategoriesParamUniversalOptional.required({
    type: true,
    id: true,
  });
